import React, { useEffect, useState } from 'react'
import { DialogContent, Dialog } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { isDarkMode } from '../../services/helper'
import { CardItem } from '../CardItem'
import { useAppContext } from '../AppContext'
import { Action, AppContextState } from '../../types'
import { inviteActions } from '../../services/helpers'

const ModalWorkflowSelector = () => {
	const navigate = useNavigate()
	const { state } = useAppContext()
	const { siteConfig, invite } = state as unknown as AppContextState

	const [
		languageSelectorModalActions,
		setLanguageSelectorModalActions,
	] = useState<Action[] | []>([])

	useEffect(() => {
		if (
			invite?.emailAddress &&
			!invite.completedLoanApplication &&
			siteConfig?.enabledServices.spanishFullApp &&
			siteConfig?.enabledServices.fullApp
		) {
			setLanguageSelectorModalActions(
				invite.loanRole
					? inviteActions[
							invite.loanRole as keyof typeof inviteActions
						]
					: []
			)
		}
	}, [
		invite,
		siteConfig?.enabledServices.fullApp,
		siteConfig?.enabledServices.spanishFullApp,
	])

	const handleAppSelection = (action: Action) => {
		setLanguageSelectorModalActions([])
		setTimeout(() => {
			navigate(`/${action.route}`, { state: action })
		}, 500)
	}

	if (languageSelectorModalActions.length <= 1) {
		return null
	}

	return (
		<Dialog
			open={!!languageSelectorModalActions.length}
			aria-labelledby="responsive-dialog-title"
		>
			<DialogContent>
				<div>
					{siteConfig?.logoUrl && (
						<img
							src={
								isDarkMode() && siteConfig.darkModeLogoUrl
									? siteConfig.darkModeLogoUrl
									: siteConfig.logoUrl
							}
							alt={`${siteConfig.companyName} Logo`}
						/>
					)}
				</div>
				<div className="text-center mt-5 mb-4 font-bold text-lg">
					Please select your preferred application...
				</div>
				<div className="w-full flex">
					{languageSelectorModalActions.map((action, index) => {
						return (
							<CardItem
								item={action}
								key={action.id}
								index={index}
								onClick={() => handleAppSelection(action)}
								source="Modal"
								notificationCount={undefined}
							/>
						)
					})}
				</div>
			</DialogContent>
		</Dialog>
	)
}

export default ModalWorkflowSelector
